import styled from "styled-components";
export const Link = styled.a`
  align-items: center;
  display: inline-flex;
  text-decoration: none;
  color: ${props => props.theme.palette.action.primary};
  ${props => props.theme.typography.link};

  &:hover,
  &:focus {
    cursor: pointer;
    text-decoration: underline;
    color: ${props => props.theme.palette.action.darker};
  }
`;